import { render, staticRenderFns } from "./commentAction.vue?vue&type=template&id=3cecf160&"
import script from "./commentAction.vue?vue&type=script&lang=js&"
export * from "./commentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports